/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { CreateFileInput } from './create-file-input';
import { AssetTypes, SaleInterestPayoutPeriod } from '../types/utils';

export class CreateSaleInput {
	assetType: AssetTypes = AssetTypes.LOAN

	startDate: Date = new Date()

	endDate: Date = new Date()

	sharesCap: number = 0

	minPurchase: number = 0

	maxPurchase: number = 0

	interestRate: number = 0

	interestPayoutPeriod: SaleInterestPayoutPeriod = SaleInterestPayoutPeriod.YEARLY

	fee: number = 0

	name: string = ''

	description: string = ''

	company: string = ''

	baFinId: string = ''

	images?: Array<CreateFileInput>
}